import validate from "/home/runner/work/favoritely/favoritely/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/favoritely/favoritely/frontend/middleware/auth.global.ts";
import maintenance_45global from "/home/runner/work/favoritely/favoritely/frontend/middleware/maintenance.global.js";
import sitemaps_45global from "/home/runner/work/favoritely/favoritely/frontend/middleware/sitemaps.global.js";
import manifest_45route_45rule from "/home/runner/work/favoritely/favoritely/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  maintenance_45global,
  sitemaps_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}